"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = void 0;
/**
 * Wrapper around clocks which are used in `EverscaleStandaloneClient` instances
 *
 * @category Client
 */
class Clock {
    constructor(offset) {
        this.impls = [];
        this.currentOffset = 0;
        if (offset != null) {
            this.currentOffset = offset;
        }
    }
    /**
     * Clock offset in milliseconds
     */
    get offset() {
        return this.currentOffset;
    }
    /**
     * Set clock offset in milliseconds
     */
    set offset(value) {
        this.currentOffset = value;
        for (const impl of this.impls) {
            impl.updateOffset(this.currentOffset);
        }
    }
    /**
     * Returns current time in milliseconds
     */
    get time() {
        return new Date().getTime() + this.offset;
    }
    /**
     * Detaches all affected providers
     *
     * NOTE: affected providers offset remains the same
     */
    detach() {
        this.impls = [];
    }
}
exports.Clock = Clock;
